import { z } from 'zod';
import { apiUrl } from '../config/api';
import type { WBS } from '../data/databaseSchema';
import { apiClient } from '../lib/apiClient';
import { envelopeSchema, wbsSchema } from '../lib/schemas';

export const wbsService = {
  getWbs: async (): Promise<WBS[]> => {
    const result = await apiClient.get(apiUrl.wbs(), {
      validate: envelopeSchema('wbs_list', z.array(wbsSchema)),
      deduplicate: true,
      context: 'getWbs',
    });
    return result.wbs_list;
  },

  async createWbs(wbs: Partial<WBS>): Promise<WBS> {
    const result = await apiClient.post(apiUrl.wbs(), wbs, {
      validate: envelopeSchema('wbs', wbsSchema),
      context: 'createWbs',
    });
    return result.wbs;
  },

  async updateWbs(id: string, wbs: Partial<WBS>): Promise<WBS> {
    const result = await apiClient.put(apiUrl.wbs(id), wbs, {
      validate: envelopeSchema('wbs', wbsSchema),
      context: 'updateWbs',
    });
    return result.wbs;
  },

  async deleteWbs(id: string): Promise<void> {
    await apiClient.delete(apiUrl.wbs(id), {
      context: 'deleteWbs',
    });
  },
};
